/*
 * Module for the Report Link control
*/

rs.module("controls/reportlink",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // hide popup once a fas option is clicked
            $.js(jsSelectors.reportLink, { multiple: true }).click(function () {
                $.js(jsSelectors.maskSSNPopup).modal('hide');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);